/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Icon } from 'vant';
import { Component, Prop, Vue } from 'vue-property-decorator';

const style = require('./index.module.scss');
const rejectIcon = require('./images/reject.png');
const groupIcon = require('./images/group.png');

@Component({ name: 'ApllyCommonHeader' })
export default class ApllyCommonHeader extends Vue {
  @Prop(String)
  private contentText!: string;

  @Prop(Array)
  private contentDescText!: string[];

  @Prop({
    type: Boolean,
    default: false,
  })
  private applyFailed!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  })
  private applyReject!: boolean;

  private render() {
    return (
      <div class={style.ApllySuccessHeader}>
        <div class={style.header}>
          {!this.applyFailed && !this.applyReject && (
            <div>
              <Icon name="checked" color="#07c160" size="70px" />
            </div>
          )}
          {this.applyFailed && (
            <div>
              <img src={rejectIcon} class={style.header_img} />
            </div>
          )}
          {this.applyReject && (
            <div>
              <img src={groupIcon} class={style.header_img} />
            </div>
          )}
          <h1 class={style.header_text}>
            {this.contentText}
          </h1>
          <p class={style.header_span}>
            {this.contentDescText && this.contentDescText.map((item) => (
              <div>{item}</div>
            ))}
          </p>
        </div>
      </div>
    );
  }
}
